import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import TenantManager from './../../components/tenantManager';
import tenants from './tenants';

import './documents.css';

class DocumentsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <TenantManager {...tenants} page={DocumentsPage.meta} />
            </div>
        );
    }
}

DocumentsPage.meta = {
    label: <FormattedMessage id={'documents'} defaultMessage={'Documents'} />,
    icon: 'library_books',
    action: () => history.push('/documents'),
    locations: ['/documents']
};

export default DocumentsPage;



// WEBPACK FOOTER //
// ./src/pages/documents/index.jsx